// extracted by mini-css-extract-plugin
module.exports = {"smallCard":"smallCard--wXik4","statCard":"statCard--PQ+NE","statCardElement":"statCardElement--t4UD+"};